export const SearchSummaryBackground = () => {
  return (
    <svg
      width="176"
      height="99"
      viewBox="0 0 176 99"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_12_15)">
        <mask
          id="mask0_12_15"
          style={{ maskType: 'alpha' }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="176"
          height="99"
        >
          <path d="M176 0H0V99H176V0Z" fill="#171623" />
        </mask>
        <g mask="url(#mask0_12_15)">
          <g opacity="0.8">
            <path
              opacity="0.5"
              d="M314.404 -14.2363C176.404 -5.23634 36.9043 -3.73633 -1.56078 169.877L-23.5957 -28.7362L314.404 -14.2363Z"
              fill="url(#paint0_linear_12_15)"
            />
            <path
              opacity="0.3"
              d="M272.174 -73.236C43.4985 -31.2417 -23.769 75.8311 -15.7318 119.598L-40.5957 -15.8008L272.174 -73.236Z"
              fill="url(#paint1_linear_12_15)"
            />
          </g>
        </g>
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_12_15"
          x1="187.904"
          y1="-21.2363"
          x2="32.2636"
          y2="90.0669"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.321249" stopColor="#6E35CB" />
          <stop offset="1" stopColor="#6E35CB" stopOpacity="0" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_12_15"
          x1="-7.0957"
          y1="42.2637"
          x2="159.904"
          y2="-42.2363"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.18569" stopColor="#6E35CB" />
          <stop offset="0.80421" stopColor="#171623" />
        </linearGradient>
        <clipPath id="clip0_12_15">
          <rect width="176" height="99" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
